import { useHandler } from "@redotech/react-util/hook";
import { LocaleSelector } from "@redotech/redo-i18n/locale-selector";
import { memo, useContext } from "react";
import { savePreferredLocale } from "../../lib/save-preferred-locale";
import { OnboardingV2RpcClientContext } from "../../rpc-client";

export const SetupLocaleSelector = memo(function SetupLocaleSelector() {
  const rpcClient = useContext(OnboardingV2RpcClientContext);
  const handleLocaleChange = useHandler((locale: string) => {
    if (rpcClient) {
      savePreferredLocale(rpcClient, locale);
    }
  });

  return <LocaleSelector onLocaleChange={handleLocaleChange} />;
});
